import { action, observable, computed, toJS } from "mobx";
import PagerStore from "./utility/PagerStore";
import {
  SORT_AMOUNT,
  SORT_CREATED,
  SORT_TERMINATED,
  SORT_ID,
  SORT_MACHINE,
  SORT_CLEANINGRATE,
  SORT_SUPPLIER,
  SORT_LOTNO,
  SORT_LOCATION,
  SORT_ITEM,
  SORT_PURITY,
  SORT_ALIENSEED,
  SORT_HARDSEED,
  SORT_WATER,
} from "../Containers/Qualities/Qualities";
import { formatDate } from "utility.js";
import { formatDateOnly } from "../utility";

const STORE_QUALITIES = "qualities";

const SORT_ASC = "asc";
const SORT_DESC = "desc";

class QualitiesStore {
  pager;
  configStore;
  authStore;

  constructor(rawState = {}, configStore, authStore) {
    this.configStore = configStore;
    this.authStore = authStore;
    this.pager = new PagerStore(rawState.pager);

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
    if (rawState.sortField) {
      this.setSortField(rawState.sortField);
    }
    if (rawState.sortDirection) {
      this.setSortDirection(rawState.sortDirection);
    }
    if (rawState.sealnums) {
      this.setSealnums(rawState.sealnums);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
      pager: toJS(this.pager),
      sortField: toJS(this.sortField),
      sortDirection: toJS(this.sortDirection),
      sealnums: toJS(this.sealnums),
    };
  }

  @observable uploading = false;
  @action setUploading(value = true) {
    this.uploading = value;
  }

  @observable items = [];
  @action setItems(value) {
    this.items = value.map((item) => {
      const name = this.configStore.items[item.ItemId];
      item.LotNo = parseInt(item.LotNo);
      item.QualityAlienseed =
        item.QualityAlienseed == -1.0 ? "Ny" : item.QualityAlienseed;
      item.ItemName =
        typeof name !== "undefined"
          ? name + (item.ItemRate ? " " + item.ItemRate : "")
          : "-";
      item.MachineText =
        this.configStore.machines[item.MachineId].Name +
        (item.CleaningCount ? " x" + item.CleaningCount : "");
      item.CleaningRateText =
        this.configStore.cleaningRates[item.CleaningRate].split("-")[1];
      item.Supplier = this.configStore.suppliers[item.SupplierId];
      item.Created = formatDate(item.Created);
      item.Terminated = item.Terminated ? formatDate(item.Terminated) : "";
      item.QualityFull = item.QualityFull ? JSON.parse(item.QualityFull) : null;
      item.FilterField = (
        (item.WeighBill ? item.WeighBill + " " : "") +
        " " +
        (item.LabId ? item.LabId + " " : "") +
        " " +
        item.LotNo +
        " " +
        (item.SealNum ? item.SealNum + " " : "") +
        item.MachineText +
        " " +
        (item.Dressing ? item.Dressing + " " : "") +
        item.Supplier +
        " " +
        (item.CustomSupplier ? item.CustomSupplier + " " : "") +
        item.ItemName +
        " " +
        (item.CustomItem ? item.CustomItem + " " : "") +
        this.configStore.cleaningRates[item.CleaningRate].split("-")[1] +
        " " +
        (item.CustomCleaningRate ? item.CustomCleaningRate + " " : "") +
        (item.BinCode
          ? item.BinCode + (item.Level != null ? "/" + item.Level : "") + " "
          : "") +
        item.Quantity +
        " " +
        (item.QualityPurity ? item.QualityPurity + " " : "") +
        (item.QualityAlienseed ? item.QualityAlienseed + " " : "") +
        (item.QualityHardseed ? item.QualityHardseed + " " : "") +
        (item.QualityWater ? item.QualityWater + " " : "") +
        item.Created +
        " " +
        (item.Terminated ? item.Terminated + " " : "")
      ).toLowerCase();
      return item;
    });
    this.pager.setItemCount(this.filteredItems.length);
  }

  @action setItem(value) {
    let item;
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].Id === value.Id) {
        item = this.items[i];
        break;
      }
    }

    if (item) {
      const name = this.configStore.items[value.ItemId];
      item.LotNo = parseInt(value.LotNo);
      item.SealNum = value.SealNum;
      item.QualityAlienseed =
        value.QualityAlienseed == -1.0 ? "Ny" : value.QualityAlienseed;
      item.ItemName = typeof name !== "undefined" ? name : "-";
      item.MachineId = value.MachineId;
      item.CleaningCount = value.CleaningCount;
      item.CustomCleaningCount = value.CustomCleaningCount;
      item.MachineText =
        this.configStore.machines[value.MachineId].Name +
        (value.CleaningCount ? " x" + value.CleaningCount : "");
      item.CleaningRate = value.CleaningRate;
      item.CleaningRateText =
        this.configStore.cleaningRates[value.CleaningRate].split("-")[1];
      item.CustomCleaningRate = value.CustomCleaningRate;
      item.SupplierId = value.SupplierId;
      item.Supplier = this.configStore.suppliers[value.SupplierId];
      item.CustomSupplier = value.CustomSupplier;
      item.Created = formatDate(value.Created);
      item.Terminated = value.Terminated ? formatDate(value.Terminated) : "";
      item.BinCode = value.BinCode;
      item.Level = value.Level;
      item.BagType = value.BagType;
      item.BagCount = value.BagCount;
      item.Quantity = value.Quantity;
      item.Status = value.Status;

      item.FilterField = (
        item.LotNo +
        " " +
        (item.SealNum ? item.SealNum + " " : "") +
        item.MachineText +
        " " +
        (item.Dressing ? item.Dressing + " " : "") +
        item.Supplier +
        " " +
        (item.CustomSupplier ? item.CustomSupplier + " " : "") +
        item.ItemName +
        " " +
        (item.CustomItem ? item.CustomItem + " " : "") +
        this.configStore.cleaningRates[value.CleaningRate].split("-")[1] +
        " " +
        (item.CustomCleaningRate ? item.CustomCleaningRate + " " : "") +
        (item.BinCode ? item.BinCode + " " : "") +
        item.Quantity +
        " " +
        (item.QualityPurity ? item.QualityPurity + " " : "") +
        (item.QualityAlienseed ? item.QualityAlienseed + " " : "") +
        (item.QualityHardseed ? item.QualityHardseed + " " : "") +
        (item.QualityWater ? item.QualityWater + " " : "") +
        item.Created +
        " " +
        (item.Terminated ? item.Terminated + " " : "")
      ).toLowerCase();
    }
  }

  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDate(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDate(this.to);
  }

  @observable showTerminated = false;
  @action changeShowTerminated() {
    this.showTerminated = !this.showTerminated;
  }

  @observable searchtext = "";
  @action setSearchText(value) {
    console.log("searchtext", value);
    this.searchtext = value;
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
    this.pager.setItemCount(this.filteredItems.length);
  }

  @observable sortField = [null, null];
  @action setSortField(value) {
    if (
      !this.sortField[0] ||
      (value == this.sortField[0] && !this.sortField[1])
    ) {
      this.sortField[0] = value;
    } else if (!this.sortField[1] || value == this.sortField[1]) {
      this.sortField[1] = value;
    } else {
      this.sortField[0] = value;
      this.sortField[1] = null;
      this.sortDirection = [null, null];
    }
  }

  @observable sortDirection = [null, null];
  @action setSortDirection(field, value) {
    if (field == this.sortField[0]) {
      this.sortDirection[0] = value;
    } else if (field == this.sortField[1]) {
      this.sortDirection[1] = value;
    }
  }
  @action flipSortDirection(field) {
    if (field == this.sortField[0]) {
      this.sortDirection[0] =
        this.sortDirection[0] === SORT_ASC ? SORT_DESC : SORT_ASC;
    } else if (field == this.sortField[1]) {
      this.sortDirection[1] =
        this.sortDirection[1] === SORT_ASC ? SORT_DESC : SORT_ASC;
    }
  }

  @computed get filteredItems() {
    if (!this.search) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        const searches = this.search.split(" ");
        for (let i = 0; i < searches.length; i++) {
          const s = searches[i].toLowerCase();
          //console.log(s, item.FilterField)
          if (item.FilterField.indexOf(s) === -1) {
            return false;
          }
        }
        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      })
    );
  }

  @computed get sortedItems() {
    if (
      (!this.sortDirection[0] && !this.sortDirection[1]) ||
      (!this.sortField[0] && !this.sortField[1])
    ) {
      return this.filteredItems;
    }

    const sortstrings = [
      SORT_MACHINE,
      SORT_CLEANINGRATE,
      SORT_SUPPLIER,
      SORT_LOCATION,
      SORT_ITEM,
      SORT_CREATED,
      SORT_TERMINATED,
    ];

    const reverse = [
      this.sortDirection[0] === SORT_ASC ? 1 : -1,
      this.sortDirection[1] === SORT_ASC ? 1 : -1,
    ];

    const sortedItems = this.filteredItems.slice().sort((a, b) => {
      if (a[this.sortField[0]] != b[this.sortField[0]]) {
        if (sortstrings.indexOf(this.sortField[0]) != -1) {
          if (!a[this.sortField[0]]) return reverse[0] * -1;
          if (!b[this.sortField[0]]) return reverse[0] * 1;
          return a[this.sortField[0]]
            ? reverse[0] *
                a[this.sortField[0]].localeCompare(b[this.sortField[0]])
            : reverse[0] * -1;
        } else {
          const v1 = parseInt(a[this.sortField[0]]);
          const v2 = parseInt(b[this.sortField[0]]);
          if (v1 != v2) return v1 > v2 ? reverse[0] * 1 : reverse[0] * -1;
        }
      } else if (this.sortField[1]) {
        if (sortstrings.indexOf(this.sortField[1]) != -1) {
          if (!a[this.sortField[1]]) return reverse[1] * -1;
          if (!b[this.sortField[1]]) return reverse[1] * 1;
          return a[this.sortField[1]]
            ? reverse[1] *
                a[this.sortField[1]].localeCompare(b[this.sortField[1]])
            : reverse[1] * -1;
        } else {
          const v1 = parseInt(a[this.sortField[1]]);
          const v2 = parseInt(b[this.sortField[1]]);
          if (v1 != v2) return v1 > v2 ? reverse[1] * 1 : reverse[1] * -1;
        }
      }
    });

    return observable(sortedItems);

    return observable(
      this.sortDirection === SORT_ASC ? sortedItems : sortedItems.reverse()
    );
  }

  @computed get shownItems() {
    return this.sortedItems.slice(
      this.pager.firstShownItem - 1,
      this.pager.lastShownItem
    );
  }

  @observable palletHistory;
  @action setPalletHistory(value) {
    this.palletHistory = value;
  }

  @observable sealnums = [];
  @action setSealnums(value) {
    this.sealnums = value;
  }

  @observable checked = [];
  @action setChecked(pallet, checked) {
    const index = this.checked.indexOf(pallet);
    if (index > -1 && !checked) {
      this.checked.splice(index, 1);
    } else if (index === -1 && checked) {
      this.checked.push(pallet);
    }
    console.log(pallet, checked, this.checked);
  }
  @action isChecked(pallet) {
    const index = this.checked.indexOf(pallet);
    if (index > -1) return true;
    return false;
  }
  @action setCheckedAll() {
    this.checked = this.filteredItems.map((i) => i.Id);
  }
  @action resetCheckedPallets() {
    this.checked = [];
  }

  @observable selectedpallets = [];
  @action setSelectedPallets(value) {
    this.selectedpallets = value;
    console.log("selectedpallets:", value);
  }

  @observable qualities = null;
  @action setQualities(value) {
    if (value.Item) value.ItemName = this.configStore.items[value.Item];
    if (value.CustomItem && value.CustomItem.length > 0)
      value.CustomItem = value.CustomItem.join(", ");
    if (this.type === "processed" && value.Sealnum)
      value.ItemName += " " + value.Sealnum;

    if (value.Machine && value.Machine !== "error")
      value.MachineName =
        this.configStore.machines[value.Machine].Name +
        (value.CleaningCount && value.MachineName
          ? " x" + value.CleaningCount
          : "");

    if (value.CleaningRate && value.CleaningRate !== "error")
      value.CleaningRateName =
        this.configStore.cleaningRates[value.CleaningRate].split("-")[1];
    if (value.CustomCleaningRate && value.CleaningRateName)
      value.CleaningRateName += " (" + value.CustomCleaningRate + ")";

    if (value.Supplier && value.Supplier !== "error")
      value.SupplierName = this.configStore.suppliers[value.Supplier];
    if (value.CustomSupplier && value.SupplierName)
      value.SupplierName += " (" + value.CustomSupplier + ")";

    if (value.User && value.User !== "error")
      value.UserName = this.configStore.users[value.User].Name;

    if (value.Timestamp && value.Timestamp !== "error")
      value.Timestamp = formatDate(value.Timestamp);

    this.qualities = value;
  }
  @action resetQualities() {
    this.qualities = {
      Item: null,
      CustomItem: null,
      Seaulnum: null,
      ItemName: null,
      Supplier: null,
      CustomSuppliers: null,
      SupplierName: null,
      Machine: null,
      MachineName: null,
      CleaninCount: null,
      CleaningRate: null,
      CustomCleaningRate: null,
      CleaninRateName: null,
      Pallets: null,
      LotNos: [],
      Quality: {
        Purity: null,
        Waste: null,
        Alienseed: null,
        GermHealthy: null,
        GermIll: null,
        GermRotten: null,
        Hardseed: null,
        Water: null,
        Vadrepce: null,
        Repcsenyretek: null,
        Vadzab: null,
        Aranka: null,
        Rumex: null,
        Tarackbuza: null,
        Szklerocium: null,
        Gabona: null,
        Nemgabona: null,
        AlienseedCount: null,
        AlienseedContract: null,
        MiscData: null,
        MiscSeed: null,
        MiscTitle: null,
        LabId: null,
        WeighBill: null,
        WeighBillQuantity: null,
      },
    };
  }
  @action setInput(input, value) {
    this.qualities.Quality[input] = value;
  }
  @action setSealnum(value) {
    this.qualities.Sealnum = value;
  }

  @observable type = null;
  @action setType(value) {
    this.type = value;
  }

  @observable qualitytypes = [
    { name: "Purity", text: "Tisztaság", type: "double" },
    { name: "Alienseed", text: "Idegenmag", type: "string" },
    { name: "Waste", text: "Hulladék", type: "string" },
    { name: "GermHealthy", text: "Ép csíra", type: "double" },
    { name: "GermIll", text: "Beteg csíra", type: "double" },
    { name: "GermRotten", text: "Rohadt", type: "double" },
    { name: "Hardseed", text: "Keménymag", type: "double" },
    { name: "Water", text: "Víz", type: "double" },
    { name: "Vadrepce", text: "Vadrepce", type: "int", processed: false },
    {
      name: "Repcsenyretek",
      text: "Repcsényretek",
      type: "int",
      processed: false,
    },
    { name: "Vadzab", text: "Vadzab", type: "string" },
    { name: "Aranka", text: "Aranka", type: "string" },
    { name: "Rumex", text: "Rumex", type: "int" },
    { name: "Tarackbuza", text: "Tarackbuza", type: "int", processed: false },
    { name: "Szklerocium", text: "Szklerócium", type: "int" },
    { name: "Gabona", text: "Gabona", type: "string" },
    { name: "Nemgabona", text: "Nem gabona", type: "string" },
    { name: "AlienseedCount", text: "Idegenmag darabszám", type: "string" },
    {
      name: "AlienseedContract",
      text: "Szerződés szerinti idegen magok",
      type: "string",
    },
    { name: "MiscData", text: "Egyéb adat", type: "string" },
    { name: "MiscSeed", text: "Egyéb mag", type: "string" },
    { name: "MiscTitle", text: "Egyéb megnevezés", type: "string" },

    { name: "LabId", text: "Labor sorszám", type: "string", hidden: true },
    { name: "WeighBill", text: "Mérlegjegy", type: "string", hidden: true },
    { name: "WeighBillQuantity", text: "Súly", type: "string", hidden: true },
  ];

  ///////////////////////////////////////////////////////////////////

  @observable weighbilltypes = [
    { name: "Id", text: "Mérlegjegy", type: "string" },
    { name: "Quantity", text: "Súly (kg)", type: "double", editable: true },
    { name: "Item", text: "", type: "string", hidden: true },
    { name: "ItemName", text: "Faj/fajta", type: "string", editable: true },
    { name: "SupplierName", text: "Partner", type: "string", editable: true },
    { name: "Place", text: "Hely", type: "string", editable: true },
    { name: "LabId", text: "Sorszám", type: "string", editable: true },
    {
      name: "ItemRate",
      text: "Szaporítási fok",
      type: "string",
      editable: true,
    },
    { name: "Timestamp", text: "Dátum", type: "string", editable: true },
    { name: "User", text: "Felhasználó", type: "string", hidden: true },
    { name: "UserName", text: "Felhasználó", type: "string" },

    { name: "Purity", text: "Tisztaság %", type: "double", editable: true },
    {
      name: "PurityTreshold",
      text: "Tisztaság határérték (%)",
      type: "double",
      editable: true,
    },
    {
      name: "PurityMultiplier",
      text: "Tisztaság szorzó",
      type: "double",
      editable: true,
    },
    { name: "Waste", text: "Hulladék (%)", type: "string", editable: true },
    {
      name: "WasteTreshold",
      text: "Hulladék határérték %",
      type: "double",
      editable: true,
    },
    {
      name: "Alienseed",
      text: "Idegenmag (%)",
      type: "string",
      editable: true,
    },
    {
      name: "AlienseedTreshold",
      text: "Idegenmag határérték (%)",
      type: "double",
      editable: true,
    },
    { name: "GermHealthy", text: "Ép csíra", type: "double", editable: true },
    {
      name: "GermHealthyTreshold",
      text: "Ép csíra határérték (%)",
      type: "double",
      editable: true,
    },
    { name: "GermIll", text: "Beteg csíra", type: "double", editable: true },
    { name: "GermRotten", text: "Rohadt", type: "double", editable: true },
    { name: "Hardseed", text: "Keménymag", type: "double", editable: true },
    { name: "Water", text: "H2O (%)", type: "double", editable: true },
    {
      name: "WaterTreshold",
      text: "H2O határérték (%)",
      type: "double",
      editable: true,
    },
    {
      name: "Vadrepce",
      text: "Vadrepce",
      type: "int",
      editable: true,
    },
    {
      name: "Repcsenyretek",
      text: "Repcsényretek",
      type: "int",
      editable: true,
    },
    { name: "Vadzab", text: "Vadzab", type: "string", editable: true },
    {
      name: "VadzabTreshold",
      text: "Vadzab határérték",
      type: "string",
      editable: true,
    },
    { name: "Aranka", text: "Aranka", type: "string", editable: true },
    { name: "Rumex", text: "Rumex", type: "int", editable: true },
    {
      name: "Tarackbuza",
      text: "Tarackbuza",
      type: "int",
      hidden: true,
    },
    { name: "Szklerocium", text: "Szklerócium", type: "int", editable: true },
    { name: "Gabona", text: "Gabona", type: "string", editable: true },
    { name: "Nemgabona", text: "Nem gabona", type: "string", editable: true },
    {
      name: "AlienseedCount",
      text: "Idegenmag darabszám",
      type: "string",
      editable: true,
    },
    {
      name: "AlienseedContract",
      text: "Szerződés szerinti idegen magok",
      type: "string",
      hidden: true,
    },
    { name: "MiscData", text: "Egyéb adat", type: "string", hidden: true },
    { name: "MiscSeed", text: "Egyéb mag", type: "string", editable: true },
    {
      name: "MiscTitle",
      text: "Egyéb megnevezés",
      type: "string",
      editable: true,
    },
    {
      name: "DeductionPurity",
      text: "Levonás - Tisztaság (%)",
      type: "double",
    },
    {
      name: "DeductionWater",
      text: "Levonás - Víztartalom (%)",
      type: "double",
    },
    {
      name: "DeductionGerm",
      text: "Levonás - Csíra (%)",
      type: "double",
      editable: true,
    },
    {
      name: "AlienseedMultiplier",
      text: "Idegenmag Kiegészítő szorzó",
      type: "double",
      editable: true,
    },
    {
      name: "DeductionAllPerc",
      text: "Összes levonás számolt (%)",
      type: "double",
    },
    {
      name: "DeductionAllKg",
      text: "Összes levonás számolt (kg)",
      type: "int",
    },
    {
      name: "DeductionAll",
      text: "Összes levonás (kg)",
      type: "int",
      editable: true,
    },
    { name: "Yield", text: "Kihozatal (kg)", type: "string" },
    {
      name: "SpecialCleaning",
      text: "Speciális tisztítások",
      type: "string",
      editable: true,
    },
    { name: "Comment", text: "Megjegyzés", type: "string", editable: true },
  ];

  @observable weighbill = null;
  @action setWeighBill(value) {
    const tresholds = this.configStore.weighbillTresholds[value.Item];
    const { weighbillMultipliers } = this.configStore;

    value.UserName = value.User
      ? this.configStore.users[value.User].Name
      : null;
    if (tresholds) {
      if (value.PurityTreshold == null) value.PurityTreshold = tresholds.Purity;
      if (value.GermHealthyTreshold == null)
        value.GermHealthyTreshold = tresholds.Germ;
      if (value.WaterTreshold == null) value.WaterTreshold = tresholds.Water;
      if (value.AlienseedTreshold == null)
        value.AlienseedTreshold = tresholds.Alienseed;
    }

    if (
      value.PurityMultiplier === null ||
      value.PurityMultiplier === undefined
    ) {
      let purityMultiplier;
      for (let i = 0; i < weighbillMultipliers.length; i++) {
        const weighbillMultiplier = weighbillMultipliers[i];
        if (value.Purity >= weighbillMultiplier[0]) {
          purityMultiplier = weighbillMultiplier[1];
          break;
        }
      }
      value.PurityMultiplier = purityMultiplier;
    }

    console.log(value);

    this.weighbill = value;
  }
  @action resetWeighBill() {
    const weighbill = {};
    this.weighbilltypes.forEach((weighbilltype) => {
      weighbill[weighbilltype[0]] = null;
    });
    this.weighbill = weighbill;
  }
  @action setWeighBillInput(input, value) {
    const weighbilltype = this.weighbilltypes.find((weighbilltype) => {
      return weighbilltype.name == input;
    });
    this.weighbill[input] = value;
  }
  @action normalizeWeighBill() {
    this.weighbilltypes.forEach((weighbilltype) => {
      if (weighbilltype.type === "int") {
        this.weighbill[weighbilltype.name] = this.weighbill[weighbilltype.name]
          ? parseInt(this.weighbill[weighbilltype.name])
          : null;
      }
      if (weighbilltype.type === "double") {
        this.weighbill[weighbilltype.name] = this.weighbill[weighbilltype.name]
          ? parseFloat(this.weighbill[weighbilltype.name])
          : null;
      }
    });
  }

  @observable selectedWeighBill;
  @action setSelectedWeighBill(value) {
    this.selectedWeighBill = value;
  }
}

export { QualitiesStore, STORE_QUALITIES, SORT_ASC, SORT_DESC };
